import {
  DataModuleEntityRaw,
  dataModuleEntityRaw,
} from '@edgvr-front/data/domain';
import { Validate } from '@edgvr-front/util/validate';

export class DataModulesListResponseDTO {
  private static validation = Validate.compile(
    DataModulesListResponseDTO.validationSchema()
  );

  constructor(readonly data: DataModulesListResponseDTORaw) {
    Validate.assert(DataModulesListResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: ['dataModules', 'count'],
      properties: {
        dataModules: {
          type: 'array',
          items: dataModuleEntityRaw,
        },
        count: {
          type: 'number',
          minimum: 0,
          maximum: Number.MAX_SAFE_INTEGER,
        },
      },
    };
  }
}

interface DataModulesListResponseDTORaw {
  dataModules: DataModuleEntityRaw[];
  count: number;
}
